
$(document).ready(function () {

    $(document).on('click', '.svg-number-icon', function(e) {
      e.preventDefault();
      console.log('hii');
      $(this).toggleClass('open-image');
      $(this).closest('.row').find('.mobile-slide-image').slideToggle();
    });
  
    $(document).on('click', '.tab-navigation', function(e) {
        e.preventDefault();
       // Remove 'active' class from all tabs
      $('.tab-navigation').removeClass('active');
      
      // Add 'active' class to the clicked tab
      $(this).addClass('active');
        var pageHandle = $(this).data('handle');
      
        if (pageHandle === 'menu-kiddos' || pageHandle === 'menu-brunch' || pageHandle === 'menu-dessert') {
            $('.main-menu-page-section').addClass('menu-active');
        } else {
            $('.main-menu-page-section').removeClass('menu-active');
        }
      
      
        $.ajax({
            type: 'GET',
            url: '/pages/' + pageHandle,
            success: function(response) {
              console.log(response);
              document.getElementById('all-tabs-list-data').innerHTML = new DOMParser()
  .parseFromString(response, 'text/html')
  .getElementById('menu-sub-pages-section').innerHTML;
              // document.getElementById('MainContent').innerHTML = new DOMParser().parseFromString(response, 'text/html').getElementById('#MainContent').innerHTML;
            }
        });
    });


   $(document).on('click', '.image-title-section .texts-heading', function(e) {
     e.preventDefault();
    $('.image-title-section .texts-heading').removeClass('active');
    $(this).addClass('active');

    // Get the ID of the clicked heading
    var headingId = $(this).attr('id');
    var sectionId = headingId.replace('heading', 'section');

    // Smooth scroll to the corresponding section with an offset of 20 pixels
    $('html, body').animate({
      scrollTop: $('#' + sectionId).offset().top - 20 // Offset by 20 pixels for padding
    }, 1000); // Duration in milliseconds for smooth scroll
  });

});
